import { seedRoutes } from './seed/routes';

const API_VALUES_URL = process.env.REACT_APP_API_VALUES + '/api';

export const endpoints = {
  [seedRoutes.obterValores]: API_VALUES_URL,
};
